export default defineNuxtRouteMiddleware((to) => {
  if (to.path === '/' || to.path.endsWith('/')) {
    return
  }

  // skip static file requests like /og-image.png
  if (/\.[a-z0-9]+$/i.test(to.path)) {
    return
  }

  return navigateTo(
    { path: `${to.path}/`, query: to.query, hash: to.hash },
    { replace: true }
  )
})
